// Library imports
import React, { useRef, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

// Meridian imports
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import Menu, { MenuItem } from "@amzn/meridian/menu";
import infoTokens from "@amzn/meridian-tokens/base/icon/info";

// Local imports
import { supportedLanguages } from "i18n/supportedLanguages";
import { keys } from "i18n/keys";

export default function LanguagePicker() {
  const buttonRef = useRef();

  const { t, i18n } = useTranslation();

  const [open, setOpen] = useState(false);
  const onOpen = useCallback(() => setOpen(true), []);
  const onClose = useCallback(() => setOpen(false), []);

  return (
    <>
      <Button data-testid="languageButton" ref={buttonRef} type="icon" onClick={onOpen}>
        {t(keys.LANGUAGE)}
        <Icon tokens={infoTokens}>Language</Icon>
      </Button>
      <Menu
        anchorNode={buttonRef.current}
        open={open}
        position="bottom"
        onClose={onClose}
        data-testid="languageMenu"
      >
        {Object.keys(supportedLanguages).map((lng) => (
          <MenuItem data-testid={lng} key={lng} onClick={() => i18n.changeLanguage(lng)}>
            {supportedLanguages[lng]}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
